import { LocationType } from '../types';
import type { ComputedRef } from 'vue';
import type { Experience } from '@experience/exp-card/dist/types/experience';

export function useTourLabel(location: ComputedRef<LocationType | undefined>) {
  const getTypeLabel = (geo: Experience['geo']) => {
    switch (location.value) {
      case LocationType.REGION:
        return undefined;
      case LocationType.COUNTRY:
        return geo?.region?.[0].name;
      default:
        return undefined;
    }
  };

  return {
    getTypeLabel,
  };
}
